import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["tag is-light", _ctx.colorClass]),
    title: `${_ctx.value * 100}%`
  }, _toDisplayString((_ctx.value * 100).toFixed()) + "%", 11, _hoisted_1))
}